import { PlannerBase } from '../../planner_base';
import watch   from "redux-watch";
import isEqual from 'is-equal';
import moment from 'moment';
import TimeLag from 'utilities/timelag';
import {
  Global,
  LineSelectedSchedule,
  LineSelectedTask,
  LineOverSchedule
} from '../model';
import {
  PLANNER_OVER_SCHEDULE,
  PLANNER_SHOW_SCHEDULE_TT,
  PLANNER_OUT_SCHEDULE,
  PLANNER_HIDE_SCHEDULE_TT,
  PLANNER_CLICK_SCHEDULE,
  PLANNER_DRAG_SCHEDULE,
  PLANNER_CLICK_START_LEFT,
  PLANNER_CLICK_START_RIGHT,
  PLANNER_CLICK_END_LEFT,
  PLANNER_CLICK_END_RIGHT,
  PLANNER_DRAG_START,
  PLANNER_DRAG_END,
  PLANNER_CLICK_MEMO
} from 'apps/events';
import PlannerControllerBase from './base';
import { NewValuesFormsTasksUpdate } from './new_values/forms_tasks_update';
import { NewValuesFormsTasksMemosSave } from './new_values/forms_tasks_memos_save';
import { NewValuesTooltipSchedule } from './new_values/tooltip_schedule';
export default class ScheduleController extends PlannerControllerBase {
  updateLag: TimeLag;
  constructor(tag){
    super(tag);
    this.updateLag = new TimeLag((params) => { this.updateScheduleDo(params); }, 100)
    this.customEvent(PLANNER_OVER_SCHEDULE, (e) => { this.onOverSchedule(e) })
    this.customEvent(PLANNER_OUT_SCHEDULE, (e) => { this.onOutSchedule(e) })
    this.customEvent(PLANNER_CLICK_SCHEDULE, (e) => { this.onClickSchedule(e) })
    this.customEvent(PLANNER_DRAG_SCHEDULE, (e) => {this.onDragSchedule(e) })
    this.customEvent(PLANNER_CLICK_START_LEFT, (e) => {this.onClickStartLeft(e) })
    this.customEvent(PLANNER_CLICK_START_RIGHT, (e) => {this.onClickStartRight(e) })
    this.customEvent(PLANNER_CLICK_END_LEFT, (e) => {this.onClickEndLeft(e) })
    this.customEvent(PLANNER_CLICK_END_RIGHT, (e) => {this.onClickEndRight(e) })
    this.customEvent(PLANNER_DRAG_START, (e) => {this.onDragStart(e) })
    this.customEvent(PLANNER_DRAG_END, (e) => {this.onDragEnd(e) })
    this.customEvent(PLANNER_CLICK_MEMO, (e) => {this.onClickMemo(e) })
  }
  // スケジュールがマウスオーバーされた（同じスケジュールでも日付が違うときはイベントが起こる）
  onOverSchedule(e){
    let overSchedule:LineOverSchedule = e.detail;
    let currentOverSchedule:LineOverSchedule = Global.getPlannerData().overSchedule;
    if(currentOverSchedule && currentOverSchedule.isSame(overSchedule)){ return; }
    let newVal = {
      orders_planner: {
        overSchedule: overSchedule
      }
    };
    NewValuesTooltipSchedule.set(newVal, overSchedule);
    let event = new CustomEvent(PLANNER_SHOW_SCHEDULE_TT, {detail: newVal});
    document.dispatchEvent(event);
    // this.updatePlanner(newVal);
  }
  // スケジュールがマウスアウトされた
  onOutSchedule(e){
    // this.updatePlanner({
    //   orders_planner: { overSchedule: null }
    // });
    let event = new CustomEvent(PLANNER_HIDE_SCHEDULE_TT);
    document.dispatchEvent(event);
  }
  // スケジュールのセルがクリックされた
  onClickSchedule(e){
    let schedule:LineSelectedSchedule = e.detail;
    let newVal = {}
    NewValuesFormsTasksUpdate.set(newVal, schedule);
    this.updateData(newVal);
    setTimeout(() => {
      this.updatePlanner({
        orders_planner: {
          selectedSchedule: schedule,
          selectedTask: schedule.task()
        }
      });
    }, 1);
  }
  // スケジュールのセルがドラッグされた
  onDragSchedule(e){
    let stepX = e.detail.stepX;
    if(stepX == 0){ return; }
    let scheduleId = e.detail.scheduleId;
    this.updateSchedule(scheduleId, stepX, stepX);
  }
  // スタートの左ボタンが押された
  onClickStartLeft(e){
    let scheduleId = e.detail.scheduleId;
    let clickNum = e.detail.clickNum;
    this.updateSchedule(scheduleId, -clickNum, 0);
  }
  // スタートの右ボタンが押された
  onClickStartRight(e){
    let scheduleId = e.detail.scheduleId;
    let clickNum = e.detail.clickNum;
    this.updateSchedule(scheduleId, clickNum, 0);
  }
  // エンドの左ボタンが押された
  onClickEndLeft(e){
    let scheduleId = e.detail.scheduleId;
    let clickNum = e.detail.clickNum;
    this.updateSchedule(scheduleId, 0, -clickNum);
  }
  // エンドの右ボタンが押された
  onClickEndRight(e){
    let scheduleId = e.detail.scheduleId;
    let clickNum = e.detail.clickNum;
    this.updateSchedule(scheduleId, 0, clickNum);
  }
  //　スタートがドラッグされた
  onDragStart(e){
    let stepX = e.detail.stepX;
    if(stepX == 0){ return; }
    let scheduleId = e.detail.scheduleId;
    this.updateSchedule(scheduleId, stepX, 0);
  }
  //　エンドがドラッグされた
  onDragEnd(e){
    let stepX = e.detail.stepX;
    if(stepX == 0){ return; }
    let scheduleId = e.detail.scheduleId;
    this.updateSchedule(scheduleId, 0, stepX);
  }
  // メモのセルがクリックされた
  onClickMemo(e){
    let selectedMemo = e.detail
    let newVal = {
      black_over: {
        show: true
      }
    };
    NewValuesFormsTasksMemosSave.set(newVal, selectedMemo);
    this.updateData(newVal);
    this.updatePlanner({
      orders_planner: {
        selectedTasksMemo: selectedMemo
      }
    });
  }
  // スケジュールをアップデート
  private updateSchedule(scheduleId, startPlus: number, endPlus: number){
    let opts = this.getScheduleData(scheduleId);
    let startMoment = moment(opts.start_time).add(startPlus, 'day');
    let endMoment = moment(opts.end_time).add(endPlus, 'day');
    if(endMoment.isBefore(startMoment)){ // スタートとエンドが逆転している
      if(startPlus !== 0){ // スタートを変更しているのであれば
        startMoment = moment(endMoment.format('YYYY-MM-DD'))
      } else { // エンドを変更しているのであれば
        endMoment = moment(startMoment.format('YYYY-MM-DD') + ' 23:59:59');
      }
    }
    let start_time = startMoment.format(Global.timeFormat);
    let end_time = endMoment.format(Global.timeFormat);
    let baseAction = Global.getFormUpdateData().base_action;
    let action = baseAction.replace('0', scheduleId)
    this.updateLag.start({scheduleId: scheduleId, action: action, startMoment: startMoment, endMoment: endMoment });
    let newVal = {}
    newVal[this.dataScopeSchedule(scheduleId)] = {
      start_time: start_time,
      end_time: end_time
    }
    this.updateSchedules(newVal);
  }
  updateScheduleDo(params){
    this.updateData({
      forms_schedules_update: {
        schedule_id: params.scheduleId,
        action: params.action,
        inputs: {
          daterange: {
            value: params.startMoment.format('YYYY-MM-DD') + ',' + params.endMoment.format('YYYY-MM-DD')
          }
        }
      }
    });
  }
}
